module.exports = __webpack_public_path__ + "img/video-corporativo-y-eventos_poster.b95701b2.jpg";